import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthEgresadosProvider';
import { EgresadoProvider } from "../context/EgresadoProvident"
import { Layout } from 'antd';

import FooterEgresados from "../components/EgresadosFooter";
import HeaderEgresados from "../components/EgresadosHeader";
import WelcomeSplash from '../../../component/WelcomeSplash/WelcomeSplash';

const { Content } = Layout;

export function PrivateEgresadosLayout() {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  if (isAuthenticated === null || loading) {
    return <WelcomeSplash isLoading />;
  }

  if (isAuthenticated === false) {
    return <Navigate to="/egresados/inicio-sesion" state={{ from: location }} replace />;
  }

  return (
    <Layout style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <EgresadoProvider >
        <HeaderEgresados />
        <Content style={{ paddingTop: 50 }}>
          <Outlet />
        </Content>
        <FooterEgresados />
      </EgresadoProvider>
    </Layout>
  );
}
